module.exports = __webpack_public_path__ + "static/media/deductibleQA.ddb1e259.png";